import { useEffect, useState } from "react";

/**
 * A local clock for time-based labels ("stalled for 2 h"). Ticks the UI only: Firestore changes
 * arrive over listeners, never on a polling loop.
 */
export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(timer);
  }, [intervalMs]);
  return now;
}
